<div class="h-1.5 fixed w-full z-10">
  @if (loading$() === true) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
<div class="h-full overflow-auto">
  <mat-drawer-container class="h-full overflow-auto">
    <mat-drawer mode="side" opened>
      <app-side-bar-component class="sticky"></app-side-bar-component>
    </mat-drawer>
    <mat-drawer-content>
      <ng-content></ng-content>
      <!-- Footer -->
      <app-footer-component></app-footer-component>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
